var urls=[
    'Xcx/Login/getJssdk',
    'Xcx/Login/index',
    'xcx/Login/loginValid'
]

function isWhitelist(baseUrl,apiUrl){
    for(var k in urls){
        if(apiUrl==`${baseUrl}${urls[k]}`){
            return true;
        }
    }
    return false;
}

export default isWhitelist;


// WEBPACK FOOTER //
// ./src/common/ignore-url.js